import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  title: {
    '& span': {
      fontWeight: 600,
    },
  },
  list: {
    padding: 0,
    marginLeft: `-${theme.spacing(1.5)}`,
    marginRight: `-${theme.spacing(1.5)}`,
  },
  listItem: {
    padding: `${theme.spacing(0.6)} ${theme.spacing(1)}`,
    borderBottom: `1px solid ${theme.palette.lightGrey}`,
    borderTop: `1px solid ${theme.palette.lightGrey}`,
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  collapsedList: {
    alignItems: 'center',
    backgroundColor: 'rgba(48, 85, 107, 0.03)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`,
  },
  button: {
    background: 'white',
    border: `1px solid rgba(198, 202, 198, 0.3)`,
    borderRadius: 10,
    fontSize: 12,
    flexGrow: 0,
    '&:hover': {
      background: 'white',
    },
  },
  activeButton: {
    background: 'rgba(48, 85, 107, 0.1)',
    border: '1px solid rgba(198, 202, 198, 0.2)',
    color: isKiteUser ? theme.palette.primary1 : theme.palette.primary2,
    '&:focus': {
      background: 'rgba(48, 85, 107, 0.1)',
    },
  },
  icon: {
    color: theme.palette.grey2,
  },
  circle: {
    backgroundColor: theme.palette.primary1,
    borderRadius: '50%',
    display: 'inline-block',
    height: 6,
    marginLeft: 3,
    width: 6,
  },
}));
